import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Supplier from "../../../containers/modules/master/supplier";

export default function SupplierRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="supplier"
      index
      element={
        <AccessControl
          name={"Supplier List"}
          auth={authUser}
          component={() => <Supplier authUser={authUser} />}
        />
      }
    />
  );
}
